import { useSelector } from "react-redux";

import { SupportedRegions } from "@seneca/push-notifications-service-consts";

import useArePushNotificationsSupported from "services/firebase/messaging/hooks/useArePushNotificationsSupported";

import useAppVariant from "features/common/hooks/useAppVariant";
import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";
import { getRegion } from "features/regions/selectors";

const SUPPORTED_REGIONS = SupportedRegions["assignment"];
type SupportedRegion = (typeof SUPPORTED_REGIONS)[number];

export default function useShowNotificationsPreferences() {
  const region = useSelector(getRegion);
  const isRegionSupported = region
    ? SUPPORTED_REGIONS.includes(region as SupportedRegion)
    : false;
  const isPushSupported =
    useArePushNotificationsSupported() || isNativeAppiOS();
  const enabledForVariant = useEnabledByVariant();

  return isRegionSupported && isPushSupported && enabledForVariant;
}

function useEnabledByVariant() {
  const appVariant = useAppVariant();

  const valuesByVariant = {
    seneca: true,
    senecaPrimary: false,
    plurall: false,
    goStudentLearning: false
  };

  return valuesByVariant[appVariant];
}
